import { getSchemaOwner } from '@preset-engine/ownership/get-schema-owner.js'
import { setSchemaOwner } from '@preset-engine/ownership/set-schema-owner.js'

export function ensureUserSchemaOwnership(cwd: string, schemaName: string): void {
  if (schemaName === 'settings') {
    setSchemaOwner(cwd, schemaName, 'core')
    return
  }

  const owner = getSchemaOwner(cwd, schemaName)
  if (!owner) {
    setSchemaOwner(cwd, schemaName, 'user')
  }
}
